import { pipe } from 'fp-ts/function';
import * as O from 'monocle-ts/Optional';
import { Action } from 'redux';
import { FUTURE, Future } from 'src/modules/common/types/Future';
import {
  PROJECT_LIST_REMOVE_CANCEL,
  PROJECT_LIST_REMOVE_CONFIRM,
  PROJECT_LIST_REMOVE_SUBMIT,
} from 'src/modules/project-list/actions/ProjectListActions';
import { ProjectListState } from 'src/modules/project-list/types/ProjectListState';

export function projectListRemovingReducer(state: ProjectListState, action: Action): ProjectListState {
  if (PROJECT_LIST_REMOVE_CONFIRM.is(action)) {
    return {
      ...state,
      removing: {
        project: action.data,
        status: null,
      },
    };
  }
  if (PROJECT_LIST_REMOVE_CANCEL.is(action)) {
    return {
      ...state,
      removing: null,
    };
  }
  if (PROJECT_LIST_REMOVE_SUBMIT.isPending(action)) {
    return modifyStatus(state, FUTURE.pending());
  }
  if (PROJECT_LIST_REMOVE_SUBMIT.isSuccess(action)) {
    return modifyStatus(state, FUTURE.success(undefined));
  }
  if (PROJECT_LIST_REMOVE_SUBMIT.isFailure(action)) {
    return {
      ...state,
      removing: null,
    };
  }

  return state;
}

function modifyStatus(state: ProjectListState, status: Future<void>): ProjectListState {
  return pipe(
    O.id<ProjectListState>(),
    O.prop('removing'),
    O.fromNullable,
    O.prop('status'),
    O.modify(() => status),
  )(state);
}
